import { ContentStatus } from 'services/graphql/generated/schemas';

export const isPackageEditable = (status: ContentStatus | undefined) =>
  status !== undefined && ![ContentStatus.Deployed, ContentStatus.Published].includes(status);
